export const AI_VEHICLE_SUGGESTION_ENABLED = "AIVehicleSuggestionEnabled";
export const AI_VEHICLE_REVIEW_ENABLED = "AIVehicleReviewEnabled";
export const OCR_EXPENSE_CLAIM_RECEIPT_ENABLED =
  "OCRExpenseClaimReceiptEnabled";
export const AP_EXTERNAL_CLIENT_URL = "APExternalClientURL";
export const CRM_CLIENT_URL = "CRMClientURL";
export const AP_EV_HOME_CHARGING_RATE = "APEVHomeChargingRate";
export const FF_DRIVER_PORTAL_ENABLED = "FFDriverPortalEnabled";
export const AI_CONSENT_PROMPT_ENABLED = "AIConsentPromptEnabled";
export const ALLOWED_LATEST_DOSSIER_REDIRECT_ROUTES =
  "AllowedLatestDossierRedirectRoutes";
export const VEHICLE_SEARCH_ENABLED = "VehicleSearchEnabled";
export const VEHICLE_CLASS_SEGMENT_MAP = "VehicleClassSegmentMap";
export const VEHICLE_BODY_TYPE_SEGMENT_MAP = "VehicleBodyTypeSegmentMap";
export const AP_QUOTE_HIDE_INVALID_CALCULATIONS_ENABLED =
  "APQuoteHideInvalidCalculationsEnabled";
export const AP_DEFAULT_VEHICLE_DEALER_PROCUREMENT_FEE =
  "APDefaultVehicleDealerProcurementFee";
export const FF_EMPLOYER_PAYROLL_TAX_SAVINGS = "FFEmployerPayrollTaxSavings";
export const PAYROLL_TAX_SAVINGS_DISPLAY_THRESHOLD =
  "PayrollTaxSavingsDisplayThreshold";

export type Configuration = {
  key: string;
  value: string | null;
  description: string | null;
  crmId: string;
  fileValue?: string;
  fileName?: string;
  dateValue?: string;
};

export type ConfigurationMap = Record<string, Configuration>;
